import {ACTION_TYPES} from "@/store/types";

export const accountModule = {
    state: {
        isLoggedIn: false,
        account: null,
        contractor: null,
        client: null,

        afterLogin: null,
        isLoggingIn: false,
    },
    mutations: {
        setAccount(state, account) {
            state.isLoggedIn = true;
            state.account = account;
        },
        logout(state) {
            state.isLoggedIn = false;
            state.account = null;
        },
        setAfterLogin(state, afterLogin) {
            state.afterLogin = afterLogin;
        },
        setIsLoggingIn(state, isLoggingIn) {
            state.isLoggingIn = isLoggingIn;
        },
    },
    actions: {
        [ACTION_TYPES.GET_ME]: {
            root: true,
            async handler({dispatch, commit}) {
                const response = await dispatch(ACTION_TYPES.CALL_API, {url: 'me/', opt: {disable_error_msg: true}});
                dispatch(ACTION_TYPES.SET_ME, response.body.account);
                return response;
            },
        },
        [ACTION_TYPES.SET_ME]: {
            root: true,
            handler({commit}, account) {
                commit('setAccount', account);
            },
        },
        [ACTION_TYPES.AUTHENTICATE_TEAMNOTE_JWT]: {
            root: true,
            async handler({dispatch, commit}, params) {
                await dispatch(ACTION_TYPES.CALL_API, {url: 'client/jwt/', params: params});
            },
        },
        [ACTION_TYPES.LOGIN]: {
            root: true,
            async handler({dispatch, commit}, params) {
                const response = await dispatch(ACTION_TYPES.CALL_API, {url: 'login/', params});
                dispatch(ACTION_TYPES.SET_ME, response.body.account);
                return response;
            },
        },
        [ACTION_TYPES.LOGOUT]: {
            root: true,
            async handler({state, dispatch, commit}) {
                if (state.isLoggedIn) {
                    await dispatch(ACTION_TYPES.CALL_API, {url: 'logout/', opt: {disable_error_msg: true}});
                }

                commit('logout');
            }
        },
        [ACTION_TYPES.SET_AFTER_LOGIN]: {
            root: true,
            async handler({state, dispatch, commit}, params) {
                commit('setAfterLogin', params);
            }
        },
        [ACTION_TYPES.IS_LOGGING_IN]: {
            root: true,
            handler({state, dispatch, commit}, params) {
                commit('setIsLoggingIn', params);
            }
        },
        [ACTION_TYPES.CLEAR_AFTER_LOGIN]: {
            root: true,
            async handler({state, dispatch, commit}) {
                commit('setAfterLogin', null);
            }
        },
    },
    getters: {
        account(state) {
            return state.account;
        },
        isLoggingIn(state) {
            return state.isLoggingIn;
        },
        afterLogin(state) {
            return state.afterLogin;
        },
    },
};
